<template>
  <base-dialog :value="isVisibleValue"
               title="Scraped content preview"
               variant="base"
               @cancel="isVisibleValue = false"
  >
    <template #prompt-input>
      <div v-bar class="max-h-120 overflow-auto p-4 text-left">
        <div v-if="formattedContent" v-html="formattedContent" class="preview-html" />
        <div v-else class="text-gray">No content to preview</div>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base-components/BaseDialog.vue'

export default {
  name: 'SettingsIndexesWebPagePreview',
  components: { BaseDialog },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    formattedContent: {
      type: String,
      default: ''
    }
  },
  emits: ['update:is-visible'],
  computed: {
    isVisibleValue: {
      get() {
        return this.isVisible
      },
      set(value) {
        this.$emit('update:is-visible', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-html {
  @apply text-gray-dark break-words;
}
</style>
